<!-- src/components/ShareButton.vue -->
<template>
  <div>
    <van-button @click="handleShare">分享商品</van-button>

公司信息：{{ companyInfo.id }}


用户信息：{{ userInfo.nikename }}
  </div>
    
  </template>
  
  <script>
    import {mapGetters } from 'vuex'
  export default {
    props: ['item'],
    computed: {
      ...mapGetters(['companyInfo','userInfo'])
    },
    methods: {
        laji(){
            console.log('垃圾')
        },
      handleShare() {
        window.wx.ready(() => {
            window.wx.updateAppMessageShareData({
            title: `推荐给你：${this.item.name}`,
            desc: this.item.desc,
            link: `${window.location.origin}/detail/${this.item.id}`,
            imgUrl: this.item.cover
          });
          this.$toast('分享内容已更新');
        });
      }
    }
  }
  </script>